export const CLOSE_MENU = 'CLOSE_MENU';
export const OPEN_MENU = 'OPEN_MENU';
export const RESET_MENU = 'RESET_MENU';
export const SET_ACTIVE_MENU = 'SET_ACTIVE_MENU';
